import React, { PureComponent } from 'react'
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Button,
} from '@material-ui/core'
import RegionItem from './RegionItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { hasAccess } from '../../utils/api'
import { Appcues } from '../../utils/constants'

const RegionItemEditable = EditableHOCWrapper(RegionItem)

const emptyRegion = {
  name: '',
  location: '',
  zipCodes: [],
  enabled: false,
  zoneType: 'zipCode',
}

export default class RegionsContainer extends PureComponent {
  state = {
    showEmptyRegion: false,
  }

  toogleEmptyRegion = () => {
    Appcues.track('Adding Region')
    this.setState((prevState) => ({
      showEmptyRegion: !prevState.showEmptyRegion,
    }))
  }

  onSaveNew = (region, afterSave) => {
    this.props.onSave(region, afterSave).then((res) => {
      if (res) {
        Appcues.track('New Region saved')
        this.toogleEmptyRegion()
      }
    })
  }

  render() {
    const { showEmptyRegion = false } = this.state
    const {
      regions = [],
      Geocode,
      lastModified,
      companyFeatures = {},
      regionConsumerTypeFlag = false,
    } = this.props

    const unversalScroll = regionConsumerTypeFlag ? 'unversalScroll-region' : 'unversalScroll'
    const tableScroll = regionConsumerTypeFlag ? 'table-scroll-region' : 'table-scroll'
    const { availableApps = [] } = companyFeatures
    const permitted = hasAccess()
    return (
      <Grid container>
        <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {permitted ? (
                <Button
                  variant="raised"
                  className="primary-button pull-right margin-bottom-small"
                  onClick={this.toogleEmptyRegion}
                >
                  Add Region
                </Button>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
        <Grid className={unversalScroll} item xs={12} sm={12} md={12} lg={12}>
          <Paper className="paper-page">
            <div className={tableScroll}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell style={{ minWidth: 120 }}>Zone Type</TableCell>
                    <TableCell style={{ minWidth: 180 }}>Value(s)</TableCell>
                    {regionConsumerTypeFlag && <TableCell>Allowed Consumer Types</TableCell>}
                    <TableCell>Enabled</TableCell>
                    {permitted ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {showEmptyRegion ? (
                    <RegionItemEditable
                      dataToEdit={emptyRegion}
                      lastModified={lastModified}
                      onPinUpdate={this.addPin}
                      onCancel={this.toogleEmptyRegion}
                      defaultEditMode={true}
                      Geocode={Geocode}
                      onSave={this.onSaveNew}
                      locationChanged={lastModified}
                      companyFeatures={companyFeatures}
                      regions={regions}
                      regionConsumerTypeFlag={regionConsumerTypeFlag}
                    />
                  ) : null}
                  {regions &&
                    regions.map((region, i) => {
                      return (
                        <RegionItemEditable
                          key={i}
                          dataToEdit={region}
                          Geocode={Geocode}
                          onDelete={this.props.onDelete}
                          onSave={this.props.onSave}
                          lastModified={lastModified}
                          locationChanged={lastModified}
                          companyFeatures={companyFeatures}
                          regions={regions}
                          regionConsumerTypeFlag={regionConsumerTypeFlag}
                        />
                      )
                    })}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Regions/RegionsContainer.js